import {ServerApi} from "../api.js";

$(document).on("click", "#auth-vk-button", async (e)=>{
    e.preventDefault();
    const vkState = await ServerApi.profile.getLoginVkState();
    const host = location.host === "old.yummyani.me" ? "site.yummyani.me": location.host
    const url = `https://id.vk.com/authorize?response_type=code&client_id=51869388&redirect_uri=${encodeURIComponent(
        "https://" + host + "/actions/login-vk.php",
    )}&state=${vkState}&code_challenge=dhz9Tsame7XZPtgmaQ5hwk9b49X2AbOk2hoKMZvLAAY&code_challenge_method=S256&scheme=dark&lang_id=0`;
    location.href = url;
});